/* RESPONSIBLE TEAM: team-knowledge-foundations */
export default class UrlFilter {
  static type = 'url';
  static icon = 'globe';
  static labelKey = 'articles.list.search.url-contains';

  static create({ value }: { value: string }) {
    return new UrlFilter(value);
  }

  type = UrlFilter.type;
  icon = UrlFilter.icon;
  labelKey = UrlFilter.labelKey;

  value: string;

  constructor(value: string) {
    this.value = value;
  }

  get text() {
    return this.value;
  }
}
